import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { Language } from '@/hooks/languages';
import { ImageComponent } from '../Image';

import { ScSwitchLanguageSelect } from './styled';

interface SwitchLanguageSelectProps {
  disabled: boolean;
  onChange: (value: string) => void;
  availableLanguages: Language[];
  variant?: 'full' | 'compact';
}

export const SwitchLanguageSelect = forwardRef<
  HTMLDivElement,
  SwitchLanguageSelectProps
>(({ disabled, onChange, availableLanguages, variant }, ref) => {
  const {
    i18n: { language: currentLang },
  } = useTranslation();

  return (
    <ScSwitchLanguageSelect ref={ref} variant={variant}>
      {availableLanguages.map(({ icon, name, value }) => (
        <button
          className={currentLang === value ? 'active' : ''}
          disabled={disabled}
          key={value}
          onClick={(e) => {
            e.preventDefault();
            onChange(value);
          }}
        >
          <div className="btn-content">
            <ImageComponent
              alt={currentLang}
              height={24}
              src={icon}
              width={24}
            />
            {name}
          </div>

          {currentLang === value && <div className="tick-circle-icon" />}
        </button>
      ))}
    </ScSwitchLanguageSelect>
  );
});
